import { backgroundColorClassName } from "./commonClassNames";
import type { BackgroundColorProps } from "./commonProps";

export type PaperProps = React.HTMLAttributes<HTMLDivElement> &
  BackgroundColorProps & {
    fit?: boolean;
  };

export const Paper: React.FC<PaperProps> = ({ children, fit, neutral, primary, yellow }) => {
  const className = [
    "rounded-2xl",
    fit ? "w-fit" : "w-full",
    backgroundColorClassName({ primary, neutral, yellow }),
  ].join(" ");

  return <div className={className}>{children}</div>;
};
